module.exports = __webpack_public_path__ + "img/status-2.a9d7b895.png";